import Radium from 'radium';
import styles from './styles.less';
import { observer } from 'mobx-react';


function ClipSeasonFilterSeason({ className, highlightColor, number, rolloverTextColor, selected, ...otherProps }) {
    return (
        <button
            { ...otherProps }
            className={ cx(styles.season, className, { [styles.selected]: selected }) }
            ref='button'
            style={{
                'color': selected ? highlightColor : null,
                ':hover': { 'color': Modernizr.touch ? null : highlightColor }
            }}>
            <span
                ref='seasonNumber'
                className={ styles.seasonNumber }
                style={{
                    'color': selected ? rolloverTextColor : null,
                    ':hover': { 'color': Modernizr.touch ? null : rolloverTextColor }
                }}>
                { number > 0 ? number : String.fromCharCode(10043) }
            </span>
        </button>
    );
}

ClipSeasonFilterSeason.propTypes = {
    highlightColor: React.PropTypes.string,
    number: React.PropTypes.number.isRequired,
    rolloverTextColor: React.PropTypes.string,
    selected: React.PropTypes.bool.isRequired
};

ClipSeasonFilterSeason.defaultProps = {
    selected: false
};


export default observer(Radium(ClipSeasonFilterSeason));



// WEBPACK FOOTER //
// ./src/show-page/components/clip-season-filter/season.js